import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';

import { Webhook } from 'dashboard/models/webhook';

interface State {
  webhooks: Webhook[];
}

const { reducer, actions } = createSlice<State, SliceCaseReducers<State>, string>({
  name: 'webhooks',
  initialState: {
    webhooks: [],
  },
  reducers: {
    setWebhooks: (state, action: PayloadAction<Webhook[]>) => {
      state.webhooks = action.payload;
    },
  },
});

export const { setWebhooks } = actions;
export const webhooksReducer = reducer;
